import React from 'react';
import {useTranslation} from 'react-i18next';
import {useSelector} from "react-redux";
import {StoreType} from "../../../store/spirs/types";
import {calculateExpressOdds, calculateSystemOdds, multipleRateWithFixed, undefinedToZero} from "../OddsUtils";

export const SummaryBlock: React.FC = () =>  {
    const {t} = useTranslation();
    const currentCouponType = useSelector((state: StoreType) => state.spirs.coupons.currentCouponType);
    const events = useSelector((state: StoreType) => state.spirs.coupons[currentCouponType]).filter(key => key.active);
    const rate = useSelector((state: StoreType) => state.spirs.coupons.rate[currentCouponType]);

    function stepsAmount() {
        switch (currentCouponType) {
            case 'ORDINAR':
                return events.reduce((ac, cur) => (cur.rate) ? cur.rate + ac : ac, 0);
            case 'SYSTEM':
                return rate * events.length;
            case 'EXPRESS':
                return rate;
        }
    }

    function potentialResult() {
        switch (currentCouponType) {
            case 'ORDINAR':
                let z = 0;
                for (let el of events) {
                    z += undefinedToZero(el.rate) * undefinedToZero(el.odds);
                }
                return z.toFixed(2);
            case 'SYSTEM':
                return multipleRateWithFixed(calculateSystemOdds(events), rate);
            case 'EXPRESS':
                return multipleRateWithFixed(calculateExpressOdds(events), rate);

        }
    }

    return (
        <div className="bg-[#272D33] rounded-[8px]">
            <div className="px-[10px] desktop:px-[10px] text-white">
                <Flex
                    first={currentCouponType === 'ORDINAR' ? t('coupons.acceptBlock.stepsAmount') : t('coupons.acceptBlock.stepAmount')}
                    second={stepsAmount()}
                />
                <hr className="border-[#D8D8D84D]"/>
                {(currentCouponType === 'EXPRESS') && (
                    <Flex
                        first={t('coupons.acceptBlock.totalCoefficient')}
                        second={events.length === 0 ? 0 : calculateExpressOdds(events).toFixed(2)}
                    />
                )}
                {(currentCouponType === 'EXPRESS') ? <hr className="border-[#D8D8D84D]"/> : <></>}
                <Flex
                    first={t('coupons.acceptBlock.potentialResult')}
                    second={potentialResult()}
                />
                {currentCouponType === 'SYSTEM' && events.length > 2 && <hr className="border-[#D8D8D84D]"/>}
                {currentCouponType === 'SYSTEM' && events.length > 2 && (
                    <Flex
                        first={t('coupons.acceptBlock.eventCounts')}
                        second={events.length}
                    />
                )}
            </div>

            {currentCouponType === "SYSTEM" &&
                <div>
                    <div className="grid justify-start"/>
                </div>
            }

        </div>
    );
}


const Box: React.FC<React.PropsWithChildren> = ({children}) => {
    return (
        <div className="py-[8px]">
            {children}
        </div>
    )
}

const Flex: React.FC<{first: any, second: any}> = ({first, second}) => {
    return (
        <Box>
            <div className="flex justify-between text-[12px] desktop:text-[16px] font-['Roboto'] leading-[100%] font-normal">
                <span>{first}</span>
                <span>{second}</span>
            </div>
        </Box>
    )
}
